import PropTypes from 'prop-types';
export default {
    id: PropTypes.number,
    // To give the source for the img to the picture component
    avatar: PropTypes.string,
    // The name of the contributor to be displayed on the row
    name: PropTypes.string,
    // The number of litter pieces displayed against the contributor
    litterCount: PropTypes.string,
    // The start date that indicates the day which the segment commenced
    startDate: PropTypes.string,
    // The duration of the segment to be displayed in minutes / hours / seconds
    duration: PropTypes.string,
    // The distance travelled in the segment to be displayed in meters
    distance: PropTypes.string,
    // this indicates whether the current segment is active or not
    isActive: PropTypes.bool,
    // the array of lat long objects to route
    segmentData: PropTypes.arrayOf(
        PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number,
        }),
    ),
};
